<template>
  <a :class="classes" v-bind="$attrs" v-on="$listeners"><slot /></a>
</template>

<script>
import { computed, defineComponent } from '@nuxtjs/composition-api';
import { getColorScheme } from '~/modules/common/utils/componentUtils';

export default defineComponent({
  props: {
    variant: {
      type: String,
      default: '',
    },
    colorScheme: {
      type: String,
      default: 'default',
    },
    size: {
      type: String,
      default: '',
    },
    pure: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const baseClasses = 'cursor-pointer';

    const variants = {
      pure: '',
    };

    const colorSchemes = {
      default: 'hover:text-link-primary',
      primary: 'text-anchor hover:text-anchor-hover',
      pure: '',
    };

    const sizes = {
      pure: '',
    };

    const classes = computed(() => {
      const selectedSize = props.pure ? sizes.pure : sizes[props.size];
      const selectedVariant = props.pure ? variants.pure : variants[props.variant];
      const selectedColor = props.pure ? colorSchemes.pure : getColorScheme(props.colorScheme, props.variant, colorSchemes);
      return [baseClasses, selectedVariant, selectedSize, selectedColor].filter(Boolean).join(' ');
    });

    return {
      classes,
    };
  },
});
</script>

<style></style>
